module.exports = __webpack_public_path__ + "static/media/arrival-icon.76dc6ee4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/arrival-icon.svg
// module id = 632
// module chunks = 0